import React from "react";
import PropTypes from "prop-types";

const ImportStatus = ({ run, onNewUpload }) => {
  if (!run || !["REJECTED", "CANCELLED"].includes(run.state)) return null;
  if (run.state === "CANCELLED") {
    return (
      <div role="status" data-testid="import-cancelled">
        <p>This dry run was cancelled. Return to the start screen to upload a new file.</p>
        <button type="button" className="import-button-secondary" onClick={onNewUpload}>
          Return to start screen
        </button>
      </div>
    );
  }
  const errors = run.error && Array.isArray(run.error.errors) ? run.error.errors : [];
  return (
    <div role="alert" data-testid="import-rejected">
      <p>{(run.error && run.error.message) || "The workbook could not be processed. Upload a corrected .xlsx file."}</p>
      {errors.length > 1 && (
        <ul>
          {errors.map((error, index) => (
            <li key={`${error.code}-${error.details?.columnLetter || index}`}>{error.message}</li>
          ))}
        </ul>
      )}
      <button type="button" onClick={onNewUpload}>
        Upload another workbook
      </button>
    </div>
  );
};
ImportStatus.propTypes = {
  run: PropTypes.shape({
    state: PropTypes.string,
    error: PropTypes.shape({
      message: PropTypes.string,
      errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
    }),
  }),
  onNewUpload: PropTypes.func.isRequired,
};
ImportStatus.defaultProps = { run: null };
export default ImportStatus;
